export default __webpack_public_path__ + "assets/img/preview_history_chart_blur.png";